// extracted by mini-css-extract-plugin
module.exports = {"uploadText":"UploadButton_uploadText__wSbJ-","uploadButton":"UploadButton_uploadButton__3J62f","uploadedFile":"UploadButton_uploadedFile__3VJmQ"};